import { customerApi } from '@/api'
import { IAddress } from '@/domains/ProfileDomain'
import { OKSign } from '@/domains/CommonDomain'

const BASE = '/customer'

export const CUSTOMER_API_URL = {
  DEBIT_CARD_PINCODE_COMPARE: 'customer/debit-card-pincode/confirm-pincode/compare',
  DEBIT_CARD_PINCODE_RESET: 'customer/debit-card-pincode/reset',
}

export interface IFindProfileRequest {
  isEZL?: OKSign
}

export interface IFindProfileResponse {
  imgUrl: string // 프로필이미지
  custNm: string // LINE Bank 고객실명
  usrAlias: string // 사용자별칭
  emailAdr: string // 이메일주소
  phoneNo: string // 휴대폰번호
  lineId: string // 라인사용자식별자 (uid)
  homeAddress: IAddress
  bizAddress?: IAddress // 직업 특성 상(e.g.학생,주부) 없을 수 있음
}

export function fetchProfile(data?: IFindProfileRequest): Promise<IFindProfileResponse> {
  return customerApi.post(`${BASE}/profile`, data)
}
